import type * as lazyIndex from "./lazyIndex";
/** copilot -hub-main-module has been added as a POC and will be used for demo purpose. Please remove this module if the feature didnt make it to the production. */

import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CopilotHubMainModule" */ "./lazyIndex"), { name: "CopilotHubMainModule" });

export const CopilotHubMainModule: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.CopilotHubMainModule);
